import { useEffect } from "react";
import { bootCookieConsent } from "@/lib/cookie-consent";

/**
 * Mounts the vanilla-cookieconsent banner. Config lives in
 * `src/lib/cookie-consent.ts`; this component just triggers it on first render.
 */
const CookieConsent = () => {
  useEffect(() => {
    bootCookieConsent();
  }, []);

  return null;
};

export default CookieConsent;
